module.exports = __webpack_public_path__ + "img/attention-2.0dd34ded.jpg";